import { QueryableEntityType } from 'mark43-federated-search';

export enum DexFormEntitiesKeys {
    Vehicles = 'vehicles',
    Persons = 'persons',
    Image = 'image',
    CriminalHistory = 'criminalHistory',
    Firearms = 'firearms',
    Articles = 'articles',
    Boats = 'boats',
    CanadianQuery = 'canadianQuery',
}

export const DexFormTitlesMap = {
    [DexFormEntitiesKeys.Vehicles]: 'Vehicles',
    [DexFormEntitiesKeys.Persons]: 'Persons',
    [DexFormEntitiesKeys.Image]: 'Image',
    [DexFormEntitiesKeys.CriminalHistory]: 'Criminal History',
    [DexFormEntitiesKeys.Firearms]: 'Firearms',
    [DexFormEntitiesKeys.Articles]: 'Articles',
    [DexFormEntitiesKeys.Boats]: 'Boats',
    [DexFormEntitiesKeys.CanadianQuery]: 'Canadian Query',
} as const;

export const DEX_FORMS_ORDER = [
    DexFormEntitiesKeys.Vehicles,
    DexFormEntitiesKeys.Persons,
    DexFormEntitiesKeys.Image,
    DexFormEntitiesKeys.CriminalHistory,
    DexFormEntitiesKeys.Firearms,
    DexFormEntitiesKeys.Articles,
    DexFormEntitiesKeys.Boats,
    DexFormEntitiesKeys.CanadianQuery,
] as const;

export const DEX_FORMS_KEYS_ORDER = [
    'vehicleFormBootstrapView',
    'vehicleByNameFormBootstrapView',
    'vehicleRegistrationByPlateFormBootstrapView',
    'vehicleRegistrationByVinFormBootstrapView',
    'vehicleRegistrationByNameFormBootstrapView',
    'vehicleRegistrationByOtherFormBootstrapView',
    'vehicleRegistrationByRecentQueryFilesFormBoostrapView',
    'lojackFormBootstrapView',
    'vehicleStolenFormBootstrapView',

    'personFormBootstrapView',
    'crimsFormBootstrapView',
    'personProbationFormBootstrapView',
    'personSexOffenderFormBootstrapView',
    'personWarrantDetailFormBootstrapView',
    'firearmConcealedWeaponsFormBootstrapView',

    'imageFormBootstrapView',

    'criminalHistoryIndexFormBootstrapView',
    'criminalHistoryRecordRequestFormBootstrapView',
    'criminalHistoryIdentityQueryFormBootstrapView',
    'criminalHistoryFullRecordFormBootstrapView',

    'firearmFormBootstrapView',
    'firearmsOwnersIdFormBootstrapView',

    'articleFormBootstrapView',

    'boatFormBootstrapView',

    'canadianWantedPersonFormBootstrapView',
    'canadianDriverLicenseFormBootstrapView',
    'canadianVehicleRegistrationFormBootstrapView',
] as const;

export const ATTENTION_MAX_LENGTH = 30;

export const FOCUSED_FIELD_BY_QUERYABLE_ENTITY_TYPE = {
    [QueryableEntityType.PERSON]: 'NameFirst',
    [QueryableEntityType.VEHICLE]: 'LicensePlateNumber',
    [QueryableEntityType.FIREARM]: 'SerialNumber',
    [QueryableEntityType.ARTICLE]: 'SerialNumber',
    [QueryableEntityType.BOAT]: 'BoatHullIdNumber',
    [QueryableEntityType.OTHER]: '',
};
